module.exports = __webpack_public_path__ + "static/media/SortingAlgo.8a8d9e53.png";